module.exports = __webpack_public_path__ + "img/sys1.96bab78a.png";